// NOTE: you also need to import vue-analytics library in `vue.js`
module.exports = {
	id: 'UA-XXX-X'
}



// WEBPACK FOOTER //
// ./src/config/analytics.js